var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Send_request_icon_2",
    "data-name": "Send request icon 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#d3e5ef",
    opacity: 0.493
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_",
    transform: "translate(16.406 15.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    d: "M34.01,30.465a.554.554,0,0,0-.376-.147.545.545,0,0,0-.242.056L.547,46.486a.977.977,0,0,0,.011,1.759l3.379,1.821S6.07,51.289,6.75,51.178l.165-.046s18.8-12.277,18.737-11.774S14.2,52.977,14.01,54.028s8.133,4.5,8.133,4.5a.976.976,0,0,0,1.329-.522L34.149,31.074A.55.55,0,0,0,34.01,30.465Z",
    transform: "translate(-0.001 -30.318)",
    fill: "none",
    stroke: "#053f7f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7206",
    "data-name": "Path 7206",
    d: "M34.188,51.107S36.47,63.617,37.807,64s6.017-5.54,7.355-7.737",
    transform: "translate(-28.001 -30.547)",
    fill: "none",
    stroke: "#053f7f",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCircle);
export default __webpack_public_path__ + "static/media/send-circle.757112df87c2b1554ed23b2c6b705dfc.svg";
export { ForwardRef as ReactComponent };